import { i18n } from '@shared/i18n';

import IdField from '@shared/fields/id-field';
import DateTimeField from '@shared/fields/date-time-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import EnumeratorField from '@shared/fields/enumerator-field';
import IntegerField from '@shared/fields/integer-field';
import StringField from '@shared/fields/string-field';
import { GenericModel } from '@shared/model/generic-model';
import { StripeConnectedAccountField } from '@modules/stripe/stripe-connected-account/stripe-connected-account-field';
import { UserField } from '@modules/auth/user-field';
import JsonField from '@shared/fields/json-field';

// import DateModelField from '@shared/fields/date-model-field';
// import BooleanField from '@shared/fields/boolean-field';


function label(name) {
        return i18n(`entities.stripeCharge.fields.${name}`);
}

const fields = {
        id: new IdField('id', label('id')),
        connectedAccount: StripeConnectedAccountField.relationToOne('connectedAccount', label('connectedAccount'), {}),
        type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('chargeType'), {}),
        stripeChargeId: new StringField('stripeChargeId', label('stripeChargeId'), {}),
        stripeFee: new IntegerField('stripeFee', label('stripeFee'), {}),
        applicationFee: new IntegerField('applicationFee', label('applicationFee'), {}),
        amount: new IntegerField('amount', label('amount'), {}),
        currency: new EnumeratorField('currency', label('currency'), getSharedEnumeratorField('currency'), {}),
        paymentMethod: new JsonField('paymentMethod', label('paymentMethod')),
        status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('chargeStatus'), {}),
        user: UserField.relationToOne('user', label('user'), {}),
        createdAt: new DateTimeField(
                'createdAt',
                label('createdAt'),
                ),
                updatedAt: new DateTimeField(
                        'updatedAt',
                        label('updatedAt'),
                        ),
        subproperty: new StringField('subproperty', label('subproperty'), {}),
        program: new StringField('program', label('program'), {}),
        subprogram: new StringField('subprogram', label('subprogram'), {}),
        inscription: new StringField('inscription', label('inscription'), {}),
};

export class StripeChargeModel extends GenericModel {
        static get fields() {
                return fields;
        }
}